<template>
  <v-container grid-list-md class="px-0">
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-0 pb-0">
        <v-card flat>
          <v-card-text class="pa-0 pt-6">
            <v-row class="grey lighten-4 mx-0 py-6 px-6">
              <v-col cols="12" sm="2" class="d-none d-sm-flex text-center">
                <v-avatar :size="150" color="blue lighten-5">
                  <v-img
                    fluid
                    :src="
                      current_user && current_user.foto
                        ? current_user.foto
                        : current_user && current_user.kelamin == 'P'
                        ? 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-perempuan.png'
                        : 'https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/img-default-laki.png'
                    "
                  ></v-img>
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="8" md="8" lg="8" xl="8" class="ml-3">
                <p class="headline black--text font-weight-bold mb-0 pb-0 pt-0 mt-n1">{{ pVal(current_user, "name") }}</p>
                <p class="py-0 my-0 caption">{{ pVal(current_user, "email") }}</p>
                <p v-if="!current_user.is_super_admin && false">
                  <v-alert v-if="!current_user.komunitas_id" icon="mdi-alert" cols="12" dense text type="warning" class="caption">
                    Belum bergabung dengan komunitas tertentu &nbsp;
                    <m-button outlined x-small color="orange" class="white--text ma-0 float-sm-right" textButton="Bergabung" action="pilih" @pilih="toSIMPKB()"></m-button>
                  </v-alert>
                  <span class="caption green--text" v-else>{{ pVal(current_user, "komunitas") }}</span>
                </p>
                <p class="my-4 pt-3" v-if="current_user.peran_dapodik">
                  <v-chip label class="mr-2" color="blue lighten-5 blue--text"
                    >{{ current_user.peran_dapodik.keterangan | toTitleCase }} {{ current_user.jenjang ? current_user.jenjang.keterangan : "" }}
                  </v-chip>
                </p>
              </v-col>
            </v-row>
            <div class="py-6"></div>
            <div class="py-0"></div>
            <v-row class="align-center justify-center pt-4">
              <v-col cols="12" sm="6" md="3" lg="3" align-self="center">
                <m-button
                  isBlock
                  class="mt-1"
                  dark
                  color="primary lighten-1"
                  text-button="Kembali Ke Seri"
                  icon="mdi-google-classroom"
                  action="goTo"
                  @goTo="goTo('instansi.pilih')"
                ></m-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-simple-table class="pt-6">
          <template v-slot:default>
            <tbody>
              <tr
                v-for="notification in current_user.informasi"
                :key="notification.id"
                :class="{
                  'grey lighten-2 px-2 clickable-row': notification.is_baca === 0,
                  ' px-2 clickable-row': notification.is_baca !== 0
                }"
                @click="handleRowClick(notification)"
              >
                <td v-if="$vuetify.breakpoint.mdAndUp">{{ notification.judul }}</td>
                <td class="pa-4">
                  <div>{{ stripHtml(formatMessage(notification.pesan, notification)).slice(0, 200) }}{{ stripHtml(notification.pesan).length > 200 ? "..." : "" }}</div>
                  <!-- Tautan WhatsApp Dinamis -->
                  <a :href="generateWhatsAppLink(notification)" target="_blank">Hubungi kami di WhatsApp</a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="selectedNotification && selectedNotification.pesan">
        <v-toolbar color="primary" class="font-weight-medium" dark><v-icon class="mr-2 pb-2">mdi-bell</v-icon>{{ selectedNotification.judul }}</v-toolbar>
        <v-card-text class="pt-4 black--text" v-html="formatMessage(selectedNotification.pesan, selectedNotification)"></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      selectedNotification: {},
      tautan_tes: "https://wa.me/+6282123445474?text=Halo%2C%20saya%20ingin%20menghubungi%20Anda.",
      tautan_tata_cara_tes: "https://example.com/tata-cara",
      no_wa_aduan: "+6281234567890",
      email_aduan: "mailto:aduan@example.com"
    };
  },
  methods: {
    formatMessage(message, data) {
      let div = document.createElement("div");
      div.innerHTML = message;

      const replaceTextNodes = node => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace(/\[([^\]]+)\]/g, (match, key) => data[key] || match);
        } else {
          node.childNodes.forEach(childNode => replaceTextNodes(childNode));
        }

        if (node.nodeType === Node.ELEMENT_NODE && node.hasAttributes()) {
          for (let attr of node.attributes) {
            attr.value = attr.value.replace(/\[([^\]]+)\]/g, (match, key) => data[key] || match);
          }
        }
      };

      replaceTextNodes(div);
      return div.innerHTML;
    },

    truncateHtml(html, maxLength) {
      let div = document.createElement("div");
      div.innerHTML = html;

      let length = 0;
      let truncatedHtml = "";

      function traverseNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          let remaining = html.substring(length);
          let truncatedTextContent = remaining.substring(0, Math.min(remaining.length, node.textContent.length));
          truncatedHtml += node.textContent.substring(0, truncatedTextContent.length);
          length += truncatedTextContent.length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          truncatedHtml += `<${node.nodeName.toLowerCase()}`;
          node.getAttributeNames().forEach(attr => {
            truncatedHtml += ` ${attr}="${node.getAttribute(attr)}"`;
          });
          truncatedHtml += ">";

          node.childNodes.forEach(child => traverseNode(child));

          truncatedHtml += `</${node.nodeName.toLowerCase()}`;
        }

        if (length >= maxLength) return;
      }

      traverseNode(div);

      if (length < html.length) {
        truncatedHtml += "...";
      }

      return truncatedHtml;
    },

    handleRowClick(notification) {
      this.selectedNotification = notification;
      this.dialog = true;

      if (notification.is_baca === 0) {
        return this.$store
          .dispatch("informasi/setBaca", {
            id: notification.id
          })
          .then(() => {
            this.$store.dispatch("user/fetch", "reload").catch(e => e);
          })
          .catch(e => e);
      }
    },

    goTo(val) {
      this.$router.push({
        name: val
      });
    },

    stripHtml(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },

    generateWhatsAppLink(notification) {
      const baseWhatsAppUrl = "https://wa.me/+6282123445474";
      const message = encodeURIComponent(`Halo, saya ingin menghubungi Anda tentang ${notification.judul}`);
      return `${baseWhatsAppUrl}?text=${message}`;
    }
  }
};
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}
</style>
